const ZDANIA22 = [
  {
    name: "[5 klasa] Angielski - różne",
    lang: 'en',
    zdania: [
      {
        pl: "starsi",
        de: "elderly",
      },
      {
        pl: "młodsi",
        de: "younger",
      },
      {
        pl: "To są starsi ludzie",
        de: "These are elderly people",
      },
      {
        pl: "po czterdziestce",
        de: "in his/her late forties",
      },
      {
        pl: "On jest po czterdziestce",
        de: "He is in his late forties",
      },
      {
        pl: "po trzydziestce",
        de: "in his/her late thirties",
      },
      {
        pl: "Ona jest po trzydziestce",
        de: "She is in her late thirties",
      },
      {
        pl: "w średnim wieku",
        de: "middle-aged",
      },
      {
        pl: "Ty jesteś w średnim wieku",
        de: "You are middle-aged",
      },
      {
        pl: "teenage",
        de: "w wieku nastoletnim",
      },
      {
        pl: "On jest nastolatkiem",
        de: "He is a teenager",
      },
      {
        pl: "pomarszczona twarz",
        de: "wrinkled face",
      },
      {
        pl: "Ona ma pomarszczoną twarz",
        de: "She has a wrinkled face",
      },
      {
        pl: "piegi",
        de: "wrinkles",
      },
      {
        pl: "Mam piegi na twarzy",
        de: "I have freckles on my face",
      },
      {
        pl: "pryszcze",
        de: "pimples",
      },
      {
        pl: "blizna",
        de: "scar",
      },
      {
        pl: "Człowiek z blizną na ramieniu",
        de: "Man with a scar on his arm",
      },
      {
        pl: "skóra bez skazy",
        de: "flawless skin",
      },
      {
        pl: "głowa gładko ogolona",
        de: "clean shaven head",
      },
      {
        pl: "twarz gładko ogolona",
        de: "clean shaven face/head",
      },
      {
        pl: "włosy",
        de: "hair",
      },
      {
        pl: "Ona ma piękne włosy",
        de: "She has beautiful hair",
      },
      {
        pl: "proste",
        de: "straight",
      },
      {
        pl: "On ma proste włosy",
        de: "He has straight hair",
      },
      {
        pl: "falise",
        de: "wavy",
      },
      {
        pl: "masz faliste włosy",
        de: "You have wavy hair",
      },
      {
        pl: "kręcone",
        de: "curly",
      },
      {
        pl: "Mam kręcone włosy",
        de: "I have curly hair",
      },
      {
        pl: "łysy",
        de: "bald",
      },
      {
        pl: "Ten Pan jest łysy",
        de: "This gentleman is bald",
      },
      {
        pl: "wąsy",
        de: "moustache",
      },
      {
        pl: "On ma wąsy",
        de: "He has a moustache",
      },
      {
        pl: "średniej długości",
        de: "medium length",
      },
      {
        pl: "barwione włosy",
        de: "dyed hair",
      },
      {
        pl: "ciemne włosy",
        de: "dark hair",
      },
      {
        pl: "blondynka",
        de: "blonde",
      },
      {
        pl: "siwowołosy",
        de: "grey-haired",
      },
      {
        pl: "sprawiedliwy",
        de: "fair",
      },
      {
        pl: "gra była sprawiedliwa",
        de: "The game was fair",
      },
      {
        pl: "broda",
        de: "beard",
      },
      {
        pl: "On ma średnio długą brodę",
        de: "He has a medium-length beard",
      },
      {
        pl: "kolczasty/ciernisty",
        de: "spiky",
      },
      {
        pl: "bokobrody",
        de: "sideburns",
      },
      {
        pl: "kozia bródka",
        de: "goatee",
      },
      {
        pl: "koński ogon (włosy)",
        de: "ponytail",
      },
      {
        pl: "Ona układa włosy w koński ogon",
        de: "She puts her hair in a ponytail",
      },
      {
        pl: "grzywka",
        de: "fringe",
      },
      {
        pl: "Muszę przyciąć grzywkę",
        de: "I need to cut my fringe",
      },
      {
        pl: "postawa",
        de: "posture",
      },
      {
        pl: "Przed ekranem ważna jest dobra postawa",
        de: "Good posture is important in front of the screen",
      },
      {
        pl: "ręce złożone",
        de: "hands folded",
      },
      {
        pl: "ręce na biodrach",
        de: "hands on hips",
      },
      {
        pl: "ręce w kieszeniach",
        de: "hands in pockets",
      },
      {
        pl: "ręce splecione",
        de: "hands crossed",
      },
      {
        pl: "dłonie złozone",
        de: "hands clasped",
      },
      {
        pl: "na stojąco",
        de: "standing",
      },
      {
        pl: "Przemówienie było na stojąco",
        de: "The speech was standing",
      },
      {
        pl: "na kolana",
        de: "on knees",
      },
      {
        pl: "leżący",
        de: "lying",
      },
      {
        pl: "przykucięty",
        de: "squatted",
      },
      {
        pl: "siedzący",
        de: "sitting",
      },
      {
        pl: "Jem na siedząco",
        de: "I am eating sitting",
      },
      {
        pl: "wysoki",
        de: "tall",
      },
      {
        pl: "średniego wzrostu",
        de: "average height",
      },
      {
        pl: "gruby",
        de: "fat",
      },
      {
        pl: "szczupły",
        de: "slim",
      },
      {
        pl: "cienki",
        de: "thin",
      },
      {
        pl: "chudy",
        de: "skinny",
      },
      {
        pl: "dobrze zbudowany",
        de: "well built",
      },
      {
        pl: "silnie zbudowany",
        de: "strongly built",
      },
      {
        pl: "ubrany na galowo",
        de: "formal dressed",
      },
      {
        pl: "ubrany na codzień",
        de: "casual dressed",
      },
      {
        pl: "ubraniy schludnie",
        de: "neatly dressed",
      },
      {
        pl: "Oni są dziś schudnie ubrani",
        de: "They are dressed neatly today",
      },
      {
        pl: "ubrany niechlujnie",
        de: "untidy dressed",
      },
      {
        pl: "Jesteś niechlujnie ubrany",
        de: "You are untidy dressed",
      },
      {
        pl: "ubrany w starym stylu",
        de: "old-fashioned dressed",
      },
      {
        pl: "pogniecione ubrania",
        de: "creased clothes",
      },
      {
        pl: "Mam pogniecione ubrania",
        de: "I have creased clothes",
      },
      {
        pl: "krzykwile ubrania",
        de: "flamboyant clothes",
      },
      {
        pl: "pasek",
        de: "belt",
      },
      {
        pl: "zegarek",
        de: "watch",
      },
      {
        pl: "bransoletka",
        de: "bracelet",
      },
      {
        pl: "kolczyki",
        de: "earrings",
      },
      {
        pl: "naszyjnik",
        de: "necklace",
      },
      {
        pl: "pierścionek",
        de: "ring",
      },
      {
        pl: "biżuteria",
        de: "jewellery",
      },
      {
        pl: "pierścień",
        de: "ring",
      },
      {
        pl: "pierścionek",
        de: "ring",
      },
      {
        pl: "krawat",
        de: "tie",
      },
      {
        pl: "muszka",
        de: "bow tie",
      },
      {
        pl: "okulary",
        de: "glasses",
      },
      {
        pl: "okulary przeciwsłoneczne",
        de: "sunglasses",
      },
      {
        pl: "parasol",
        de: "umbrella",
      },
      {
        pl: "torba",
        de: "bag",
      },
      {
        pl: "torba na ramię",
        de: "shoulder bag",
      },
      {
        pl: "luźne ubraniania",
        de: "baggy clothes",
      },
      {
        pl: "dzinsowe ubrania",
        de: "denim clothes",
      },
      {
        pl: "skórzane ubrania",
        de: "leather clothes",
      },
      {
        pl: "skórzane buty",
        de: "leather shoes",
      },
      {
        de: "wełniane ubrania",
        pl: "woollen clothes",
      },
      {
        pl: "ręcznie zrobione",
        de: "handmade",
      },
      {
        pl: "dobrze wyprasowane",
        de: "well pressed",
      },
      {
        pl: "w paski",
        de: "striped",
      },
      {
        pl: "w kratkę",
        de: "checked",
      },
      {
        pl: "nakrapiane",
        de: "spotted",
      },
      {
        pl: "dobrze wypolerowane buty",
        de: "well polished shoes",
      },
      {
        pl: "wygodne buty",
        de: "comfortable shoes",
      },
      {
        pl: "buty na obcasie",
        de: "high-heeled shoes",
      },
      {
        pl: "boso",
        de: "barefoot",
      },
    ],
  },
];

const ZDANIA21 = [
  {
    name: "[5klasa] Niemiecki Mod. 4 Kap. 2",
    lang: 'de',
    zdania: [
      {
        pl: "Stefan, dokąd jedziesz na ferie?",
        de: "Stefa, wohin fährst du in die Ferien?",
      },
      {
        pl: "Jadę w lecie do Włoch",
        de: "Ich fahre im Sommer nach Italien",
      },
      {
        pl: "Do Włoch, I dokład dokładnie?",
        de: "Nach Italien, und wohin genau?",
      },
      {
        pl: "Na Adriatyk, do Rimini. A ty? Dokąd jedziesz?",
        de: "An die Adria, nach Rimini. Und du? Wohin fährst du?",
      },
      {
        pl: "Zostaje w domu. niestety",
        de: "Ich bleibe zu Hause, leider",
      },
      {
        pl: "Jadę nad morze",
        de: "Ich fahre ans Meer",
      },
      {
        pl: "On jedzie nad jezioro Bodeńskie",
        de: "Er fährt ans Bodensee",
      },
      {
        pl: "Ona jedzie na morze północne",
        de: "Sie fährt ans Nordsee",
      },
      {
        pl: "Jadę nad morze Bałtyckie",
        de: "Ich fahre ans Ostsee",
      },
      {
        pl: "Ty jeszdzieś na wieś",
        de: "Du fährst aufs Land",
      },
      {
        pl: "Jadę na Kretę",
        de: "Ich fahre nach Kreta",
      },
      {
        pl: "Jadę na wyspę Sylt",
        de: "Ich fahre nach Sylt",
      },
      {
        pl: "My jedziemy w góry",
        de: "Wir fahren in die Berge",
      },
      {
        pl: "Oni jadą w Tatry",
        de: "Sie fahren in die Tatra",
      },
      {
        pl: "Jedzimy w Alpy",
        de: "Wir fahren in die Alpen",
      },
      {
        pl: "On jedzie w Himalaje",
        de: "Er fährt in die Himalaya",
      },
      {
        pl: "Jadę do Wiednia",
        de: "Ich fahre nach Wien",
      },
      {
        pl: "Ona jedzie do Zakopanego",
        de: "Sie fährt nach Zakopane",
      },
      {
        pl: "On jedzie do Madrytu",
        de: "Er fährt nach Madrid",
      },
      {
        pl: "Jedziemy do Austri",
        de: "Wir fahren nach Österreich",
      },
      {
        pl: "Jadę do Francji",
        de: "Ich fahre nach Frankreich",
      },
      {
        pl: "Oni jadę do Ameryki",
        de: "Sie fahren nach Amerika",
      },
      {
        pl: "Jadę do Grecji",
        de: "Ich fahre nach Griechenland",
      },
      {
        pl: "On jedzie do Szwajcarii",
        de: "Er fährt nach Schweiz",
      },
      {
        pl: "Ona jedzie do Turcji",
        de: "Sie fährt nach Türkei",
      },
      {
        pl: "Jadę do USA",
        de: "Ich fahre nach USA",
      },
      {
        pl: "Dokąd jedziesz na urlop?",
        de: "Wohin fährst du in Urlaub?",
      },
      {
        pl: "cudownie",
        de: "wunderbar",
      },
      {
        pl: "kalowo",
        de: "toll",
      },
      {
        pl: "to klasa [mówiąc, ze świetnie]",
        de: "klasse",
      },
      {
        pl: "szkoda",
        de: "schade",
      },
      {
        pl: "niestety",
        de: "leider",
      },
      {
        pl: "ciężko [mówiąc o czym, co jest trudne]",
        de: "schwer",
      },
      {
        pl: "przykro mi",
        de: "es tut mir leid",
      },
      {
        pl: "Który z Was jedzie nad morze?",
        de: "Wer von euch fährt ans Meer?",
      },
      {
        pl: "Który z Was zostaje w domu?",
        de: "Wer von euch bleibt zu Hause?",
      },
      {
        pl: "Dlaczego jedziesz nad morze?",
        de: "Warum fährst du ans Meer?",
      },
      {
        pl: "Chcę brać kąpiel",
        de: "Ich will baden",
      },
      {
        pl: "Dlaczego jedziesz w góry?",
        de: "Warum fährst du in die Berge?",
      },
      {
        pl: "Chcę wędrować",
        de: "Ich will wandern",
      },
      {
        pl: "Dlaczego jedziesz do Niemiec?",
        de: "Warum fährst du nach Deutschland?",
      },
      {
        pl: "Chcę zwiedzać Berlin",
        de: "Ich will Berlin besichtigen",
      },
      {
        pl: "Dlaczego jedziesz nad Adriatyk?",
        de: "Warum fährst du an die Adria?",
      },
      {
        pl: "Chcę się w słońcu duzo opalać",
        de: "Ich will viel in der Sonne liegen",
      },
      {
        pl: "Dlaczego jedziesz nad jezioro Bodeńskie?",
        de: "Warum fährst du ans Bodensee?",
      },
      {
        pl: "Chcę serfować",
        de: "Ich will surfen",
      },
      {
        pl: "Dlaczego jedziesz do Wiednia?",
        de: "Warum fährst du nach Wien?",
      },
      {
        pl: "Chcę odwiedzać Pratelln",
        de: "Ich will Pratelln besuchen",
      },
      {
        pl: "Dlaczego jedziesz do Szwajcarii?",
        de: "Warum fährst du nach Schweiz?",
      },
      {
        pl: "Chcę patrzeć na Mastterhorn",
        de: "Ich will das Mastterhorn sehen",
      },
      {
        pl: "Co chcesz tam robic?",
        de: "Was willst du dort machen?",
      },
      {
        pl: "zima",
        de: "der Winter",
      },
      {
        pl: "grudzień, styczeń, luty",
        de: "Dezember, Januar, Februar",
      },
      {
        pl: "wiosna",
        de: "der Frühling",
      },
      {
        pl: "marzec, kwiecień, maj",
        de: "März, April, Mai",
      },
      {
        pl: "lato",
        de: "der Sommer",
      },
      {
        pl: "czerwiec, lipiec, sierpień",
        de: "Juni, Juli, August",
      },
      {
        pl: "jesień",
        de: "der Herbst",
      },
      {
        pl: "wrzesień, październik, listopad",
        de: "September, Oktober, November",
      },
      {
        pl: "Kiedy jedziesz na Kretę?",
        de: "Wann fährst du nach Kreta?",
      },
      {
        pl: "Na jesieni",
        de: "Im Herbst",
      },
      {
        pl: "Kiedy jedziesz do Wiednia?",
        de: "Wann fährst du nach Wien?",
      },
      {
        pl: "Wiosną",
        de: "Im Frühling",
      },
      {
        pl: "Kiedy jedziesz do Szwajcarii?",
        de: "Wann fährst du nach Schweiz?",
      },
      {
        pl: "W lato",
        de: "Im Sommer",
      },
      {
        pl: "Kiedy jedziesz do Niemiec?",
        de: "Wann fährst du nach Deutschland?",
      },
      {
        pl: "W zimie",
        de: "Im Winter",
      },
      {
        pl: "Kiedy jedziesz na ferie letnie?",
        de: "Wann fährst du in den Sommerferien?",
      },
      {
        pl: "W marcu",
        de: "Im März",
      },
      {
        pl: "Kiedy zaczyna sie ponownie szkoła?",
        de: "Wann beginnt wieder die Schule?",
      },
      {
        pl: "W wrześniu",
        de: "Im September",
      },
      {
        pl: "Kiedy się świętuje Boże Narodzenie?",
        de: "Wann feiert man Weihnachten?",
      },
      {
        pl: "W grudniu",
        de: "Im Dezember",
      },
      {
        pl: "Kiedy jest początek lata?",
        de: "Wann beginnt der Sommer?",
      },
      {
        pl: "W czerwcu",
        de: "Im Juni",
      },
      {
        pl: "Kiedy odbywa się Oktoberfest?",
        de: "Wann findet das Oktoberfest statt?",
      },
      {
        pl: "W październiku",
        de: "Im Oktober",
      },
      {
        pl: "Pada deszcz",
        de: "Es regnet",
      },
      {
        pl: "Pada śnieg",
        de: "Es schneit",
      },
      {
        pl: "Jest zimno",
        de: "Es ist kalt",
      },
      {
        pl: "Jest gorąco",
        de: "Es ist heiß",
      },
      {
        pl: "Jest słonecznie",
        de: "Es ist sonnig",
      },
      {
        pl: "Jest pochmurno",
        de: "Es ist bewölkt",
      },
      {
        pl: "Jest wietrznie",
        de: "Es ist windig",
      },
      {
        pl: "Jest mgliście",
        de: "Es ist neblig",
      },
      {
        pl: "Jest burzowo",
        de: "Es ist stürmisch",
      },
      {
        pl: "Jest ciepło",
        de: "Es ist warm",
      },
      {
        pl: "Jest bezchmurnie",
        de: "Es ist wolkenlos",
      },
      {
        pl: "Grzmi",
        de: "Es donnert",
      },
      {
        pl: "Błyska",
        de: "Es blitzt",
      },
      {
        pl: "Jaka jest pogoda w Atenach?",
        de: "Wie ist das Wetter in Athen?",
      },
      {
        pl: "W Atenach jest słonecznie",
        de: "In Athen ist es sonnig",
      },
      {
        pl: "Jest 19 stopni",
        de: "Es sind 19 Grad",
      },
      {
        pl: "Jaka jest pogoda w Berlinie?",
        de: "Wie ist das Wetter in Berlin?",
      },
      {
        pl: "W Berlinie jest pochmurno",
        de: "In Berlin ist es bewölkt",
      },
      {
        pl: "Jest 15 stopni",
        de: "Es sind 15 Grad",
      },
      {
        pl: "Jaka jest pogoda w Styczniu?",
        de: "Wie ist das Wetter im Januar?",
      },
      {
        pl: "W grudniu jadę do St. Moritz. To jest w Szwajcarii.",
        de: "Im Dezember fahre ich nach St. Moritz. Das ist in der Schweiz.",
      },
      {
        pl: "Jadę do Szwajcarii w grudniu",
        de: "Ich fahre im Dezember nach Schweiz",
      },
      {
        pl: "Zostanę tam jeden tydzień",
        de: "Ich bleibe eine Woche da",
      },
      {
        pl: "mieszkamy w Parkhotel",
        de: "Wir wohnen im Parkhotel",
      },
      {
        pl: "Chcemy jeździć na nartach",
        de: "Wir wollen Ski fahren",
      },
      {
        pl: "zielone drzewa",
        de: "grüne Bäume",
      },
      {
        pl: "rónokolorowe drzewa",
        de: "bunte Bäume",
      },
      {
        pl: "drzewa bez liści",
        de: "Bäume ohne Blätter",
      },
      {
        pl: "źółte liście",
        de: "gelbe Blätter",
      },
      {
        pl: "zielone liście",
        de: "grüne Blätter",
      },
      {
        pl: "zielona trawa",
        de: "grünes Gras",
      },
      {
        pl: "śnieg",
        de: "Schnee",
      },
      {
        pl: "duzo słońca",
        de: "viel Sonne",
      },
      {
        pl: "mało słońca",
        de: "wenig Sonne",
      },
      {
        pl: "deszcz",
        de: "Regen",
      },
      {
        pl: "mróz",
        de: "Frost",
      },
      {
        pl: "drzewa pokryte śniegiem",
        de: "schneebedeckte Bäume",
      },
    ],
  },
];

const ZDANIA23 = [
  {
    name: "[5klasa] Niemiecki Mod. 4 Kap. 3",
    lang: 'de',
    zdania: [
      {
        pl: "Cześć Babciu, cześć Dziadku. Co robicie?",
        de: "Hallo Oma, hallo Opa. Was macht du denn?",
      },
      {
        pl: "Pakujemy prezent dla Tiny",
        de: "Wir packen Geschenk für Tina ein",
      },
      {
        pl: "Dla Tiny? Dlaczego?",
        de: "Für Tina? Warum denn?",
      },
      {
        pl: "Ojej! Zapomniałem o tym",
        de: "Oh je! Das habe ich vergessen",
      },
      {
        pl: "Alez w sobotę są jej urodziny.",
        de: "Sie hat doch am Samstag Geburtstag",
      },
      {
        pl: "Ona zostanie juz 14 latką",
        de: "Sie wird schon 14",
      },
      {
        pl: "A ile lat będziesz miała w tym roku Babiu?",
        de: "Und wie alt wirst du dieses Jahr Oma?",
      },
      {
        pl: "Będe miała 72 lata",
        de: "Ich werde 72 Jahre alt",
      },
      {
        pl: "W takim razie upiekę dla Ciebie tort marcepanowy",
        de: "Dann backe ich für dich einen Marzipan-Torte",
      },
      {
        pl: "A ile dziadku skonczysz lat w tym roku?",
        de: "Und wie alt wirst du dieses Jahr Opa?",
      },
      {
        pl: "Zgaduj",
        de: "Rate mall",
      },
      {
        pl: "Urodziłem 30 czerwca 1948 roku",
        de: "Ich bin am 30. Juni 1948 geboren",
      },
      {
        pl: "Prezent urodzinowy",
        de: "Geburtstagsgeschenke",
      },
      {
        pl: "Na urodziny duzo szczescia",
        de: "Zum Geburtstag viel Glück",
      },
      {
        pl: "Kto ma w Sobote urodziny?",
        de: "Wer hat am Samstag Geburtstag?",
      },
      {
        pl: "Co pakują dziadkowie?",
        de: "Was packen die Großeltern ein?",
      },
      {
        pl: "Tina kiedy masz urodziny?",
        de: "Tina, wann hast du Geburtstag?",
      },
      {
        pl: "W przyszłym tygodniu, 22 maja",
        de: "Nächste Woche, am 22. Mai",
      },
      {
        pl: "Ile skończysz lat?",
        de: "Wie alt wirst du?",
      },
      {
        pl: "Skończe 15 lat",
        de: "Ich werde 15 Jahre alt",
      },
      {
        pl: "I jak będzisz świetować swoje urodziny?",
        de: "Und wie feierst du deinen Geburtstag?",
      },
      {
        pl: "Chcę zrobić przyjęcie urodzinowe",
        de: "Ich möchte eine Geburtstagsparty geben",
      },
      {
        pl: "Kiedy Anna ma urodziny?",
        de: "Wann hat Anna Geburtstag?",
      },
      {
        pl: "Czternastego kwietnia",
        de: "Am 14. April",
      },
      {
        pl: "Styczeń",
        de: "Januar",
      },
      {
        pl: "Luty",
        de: "Februar",
      },
      {
        pl: "Kto ma urodziny 15 marca?",
        de: "Wer hat am 15. März Geburtstag?",
      },
      {
        pl: "Kto ma urodziny w kwietniu?",
        de: "Wer hat im April Geburtstag?",
      },
      {
        pl: "pierwszego [napisz słownie] kwietnia",
        de: "am ersten April",
      },
      {
        pl: "drugiego [napisz slownie] czerwca",
        de: "am zweiten Juni",
      },
      {
        pl: "trzeciego [napisz slownie] lipca",
        de: "am dritten Juli",
      },
      {
        pl: "czwartego [napisz slownie] sierpnia",
        de: "am vierten August",
      },
      {
        pl: "piątego [napisz slownie] września",
        de: "am fünften September",
      },
      {
        pl: "szóstego [napisz slownie] października",
        de: "am sechsten Oktober",
      },
      {
        pl: "siódmego [napisz slownie] i ósmego [napisz slownie] listopada",
        de: "am siebten und achten November",
      },
      {
        pl: "dziewiątego [napisz slownie] i dziesiątego [napisz slownie] grudnia",
        de: "am neunten und zehnten Dezember",
      },
      {
        pl: "jedenastego [napisz slownie] i dwunastego [napisz slownie] stycznia",
        de: "am elften und zwölften Januar",
      },
      {
        pl: "dwudziestego i trzydziestego pierwszego [napisz slownie] lutego",
        de: "am zwanzigsten und dreißigsten ersten Februar",
      },
    ],
  },
];

const ZDANIA24 = [
  {
    name: "[5klasa] Niemiecki Mod. 4 Kap. 3 c.d",
    lang: 'de',
    zdania: [
      {
        pl: "Czy mam przynieść coś do jedzenia?",
        de: "Soll ich etwas zum Essen mitbringen?",
      },
      {
        pl: "Czy mam przyjść o 18:00? / Mam przyjść o 18:00?",
        de: "Soll ich um 18:00 Uhr kommen?",
      },
      {
        pl: "Czy mam zaroprosić Maxa? / Mam zaroprosić Maxa?",
        de: "Soll ich Max bitten?",
      },
      {
        pl: "Czy mam coś kupic? / Mam coś kupić?",
        de: "Soll ich etwas kaufen?",
      },
      {
        pl: "Czy upiec ciastko? / Mam upiec ciastko?",
        de: "Soll ich ein Kuchen backen?",
      },
      {
        pl: "urządzać przyjęcie",
        de: "eine Party geben",
      },
      {
        pl: "Jutro urządzam przyjęcie i jesteś zaproszony",
        de: "Morgen gebe ich eine Party und du bist eingeladen",
      },
      {
        pl: "przyjść na przyjęcie",
        de: "zur Party kommen",
      },
      {
        pl: "przyjść na przyjęcie o 18:00",
        de: "um 18:00 Uhr zur Party kommen",
      },
      {
        pl: "zapraszać",
        de: "einladen",
      },
      {
        pl: "zapraszać na przyjęcie",
        de: "zur Party einladen",
      },
      {
        pl: "zapraszać na przyjęcie o 18:00",
        de: "um 18:00 Uhr zur Party einladen",
      },
      {
        pl: "zapraszać Maksa na przyjęcie",
        de: "Max zur Party einladen",
      },
      {
        pl: "Przyniosę płyty CD i upiekę ciasto.",
        de: "Ich werde CDs mitbringen und einen Kuchen backen.",
      },
      {
        pl: "Upiekę ciasto i przyniosę ciasto.",
        de: "Ich werde einen Kuchen backen und einen Kuchen mitbringen.",
      },
      {
        pl: "Być punktualnym",
        de: "pünktlich sein",
      },
      {
        pl: "Być punktualnym na przyjęcie",
        de: "pünktlich zur Party sein",
      },
      {
        pl: "Czy mam upić Pizze?",
        de: "Soll ich Pizza machen?",
      },
      {
        pl: "Kup pizzę! (w trybie rozkazującym)",
        de: "Kauf Pizza!",
      },
      {
        pl: "Podaj mi butelkę wody! (w trybie rozkazującym)",
        de: "Gib mir eine Flasche Wasser",
      },
      {
        pl: "Zaproś Maxa na przyjęcie! (w trybie rozkazującym)",
        de: "Lade Max zur Party ein!",
      },
      {
        pl: "Przykro mi, ale ni mogę",
        de: "Es tut mir leid, aber ich kann nicht",
      },
      {
        pl: "Czemu nie?",
        de: "Warum dann nicht?",
      },
      {
        pl: "Uczęszczam na kurs językowy",
        de: "Ich besuche einen Sprachkurs",
      },
      {
        pl: "Ich habe keine Zeit",
        de: "Nie mam czasu",
      },
      {
        pl: "Nie mieć czasu (bezokolicznik)",
        de: "keine Zeit haben",
      },
      {
        pl: "Odwiedzać ciocię Urlike",
        de: "Urlikes Tante besuchen",
      },
      {
        pl: "niestety",
        de: "leider",
      },
      {
        pl: "szkoda",
        de: "schade",
      },
      {
        pl: "Nie, przynieś coś do picia",
        de: "Nein, bring etwas zu trinken mit",
      },
      {
        pl: "Nie, przyjdź trochę wcześniej",
        de: "Nein, komm ein bisschen früher",
      },
      {
        pl: "Tak, zaproś Maxa",
        de: "Ja, lade Max ein",
      },
      {
        pl: "Czy przychodzisz na przyjęcie?",
        de: "Kommst du zur Party?",
      },
      {
        pl: "Badz punktualny",
        de: "Sei pünktlich",
      },
      {
        pl: "Dla kogo są te prezenty?",
        de: "Für wen sind diese Geschenke?",
      },
      {
        pl: "Dla kogo jest ta perfuma",
        de: "Für wen sind ist das Parfüm?",
      },
      {
        pl: "Ta perfuma jest dla ciebie",
        de: "Das Parfüm ist für dich",
      },
      {
        pl: "Ten prezenty są mnie",
        de: "Diese Geschenke sind für mich",
      },
      {
        pl: "Dla kogos są ten T-shirty",
        de: "Für wen sind diese T-Shirts?",
      },
      {
        pl: "Te T-shirty są dla nich",
        de: "Diese T-Shirts sind für Sie",
      },
      {
        pl: "Dla kogo są te buty?",
        de: "Für wen sind diese Schuhe?",
      },
      {
        pl: "Te buty są dla niej",
        de: "Diese Schuhe sind für sie",
      },
      {
        pl: "Dla kogo są te Praliny?",
        de: "Für wen sind diese Pralinen?",
      },
      {
        pl: "Te Praliny są dla nas",
        de: "Diese Pralinen sind für uns",
      },
      {
        pl: "Dla kogo jest ten zegarek?",
        de: "Für wen ist diese Uhr?",
      },
      {
        pl: "Ten zegarek jest dla niego",
        de: "Diese Uhr ist für ihn",
      },
      {
        pl: "Nie, one nie są dla mnie, tylko dla Was",
        de: "Nein, diese sind nicht für mich, sondern für euch",
      },
      {
        pl: "Te ksiazki są dla Was",
        de: "Diese Bücher sind für euch",
      },
      {
        pl: "Te kolczyki są dla niej",
        de: "Diese Ohrringe sind für sie",
      },
      {
        pl: "Ten prezent jest  dla Tiny i Stefana",
        de: "Dieses Geschenk ist für Tina und Stefan",
      },
      {
        pl: "Wszystkiego najlepszego z okazji urodzin",
        de: "Alles Gute zum Geburtstag",
      },
    ],
  },
];

const ZDANIA25 = [
  {
    name: "[5klasa] Angielki grudzien 2022",
    zdania: [
      {
        pl: "Zima jest często mroźna i lodowata",
        de: "Winter is often cold and icy",
      },
      {
        pl: "Mroźne poranki",
        de: "Frosty mornings",
      },
      {
        pl: "Świeze powietrze",
        de: "Fresh air",
      },
      {
        pl: "Zima często jest pochmuran i wietrzna",
        de: "Winter is often cloudy and windy",
      },
      {
        pl: "Zima czasem jest bezwietrzna i snieżna",
        de: "Winter is sometimes windless and snowy",
      },
      {
        pl: "Zima czasem jest słoneczna, a powietrze jest przejrzyste",
        de: "Winter is sometimes sunny, and the air is clear",
      },
      {
        pl: "Jutro urządzam przyjęcie i jesteś zaproszony",
        de: "Morgen gebe ich eine Party und du bist eingeladen",
      },
      {
        pl: "Pogoda moze być nudna i depresyjna",
        de: "Weather can be dull and depressing",
      },
      {
        pl: "Śliskie drogi",
        de: "Slippery roads",
      },
      {
        pl: "Temepratura ponziej zera",
        de: "Temperature below zero",
      },
      {
        pl: "W zimie pada śnieg",
        de: "In winter it snows",
      },
      {
        pl: "opad śniegu",
        de: "snowfall",
      },
      {
        pl: "Burza śnieżna jest niebezpęeczna",
        de: "A snowstorm is dangerous",
      },
      {
        pl: "Snieg pokrywa samochody",
        de: "Snow covers cars",
      },
      {
        pl: "Mikołaj przychodzi w zimie",
        de: "Santa Claus comes in winter",
      },
      {
        pl: "przychdzić",
        de: "to come",
      },
      {
        pl: "Powietrze zamarza",
        de: "The air freezes",
      },
      {
        pl: "błysk / iskra",
        de: "spark",
      },
      {
        pl: "śmiech",
        de: "laught",
      },
      {
        pl: "ukrywać się",
        de: "hide",
      },
      {
        pl: "Słońce przesuwa się",
        de: "The sun moves",
      },
      {
        pl: "poruszać się",
        de: "move",
      },
      {
        pl: "Czemu nie?",
        de: "Warum dann nicht?",
      },
      {
        pl: "Łapać śnieg",
        de: "Catch snow",
      },
      {
        pl: "Ich habe keine Zeit",
        de: "Nie mam czasu",
      },
      {
        pl: "Nosić czapkę",
        de: "Wear a hat",
      },
      {
        pl: "Ukłuć w rękę",
        de: "Sting in the hand",
      },
      {
        pl: "Noc staje się dłuzsza",
        de: "Night become lonfer",
      },
      {
        pl: "Łapać płatki śniegu",
        de: "Catch snowflakes",
      },
      {
        pl: "Zrobić baławana",
        de: "Make a snowman",
      },
      {
        pl: "Rzucać kulkami śnieżnymi",
        de: "Throw snowballs",
      },
      {
        pl: "Narty",
        de: "Ski",
      },
      {
        pl: "Łyzwa",
        de: "Skate",
      },
      {
        pl: "Iśc na sanki",
        de: "Go sledding",
      },
      {
        pl: "Dekorować domy i drzewka choinkowe na Boże Narodzenie",
        de: "Decorate houses and Christmas trees for Christmas",
      },
      {
        pl: "Robić karmniki dla ptaków",
        de: "Make bird feeders",
      },
      {
        pl: "Karmic ptaki",
        de: "Feed birds",
      },
      {
        pl: "Nosić ciepłe ubrania",
        de: "Wear warm clothes",
      },
      {
        pl: "Mróz szczypie",
        de: "Frost stings",
      },
      {
        pl: "Mieć ferie zimowe",
        de: "Have winter holidays",
      },
      {
        pl: "Wiosna jest często sucha i przyjemna",
        de: "Spring is often dry and pleasant",
      },
      {
        pl: "Wiosna może być pochmurna, deszczowa i mokra",
        de: "Spring can be cloudy, rainy and wet",
      },
      {
        pl: "Dzien jest mniej przyjemny",
        de: "The day is less pleasant",
      },
      {
        pl: "Wietrzne dni są nieprzyjemne",
        de: "Windy days are unpleasant",
      },
      {
        pl: "Bezwietrzna pogoda jest lepsza",
        de: "Windless weather is better",
      },
      {
        pl: "Słońce i niebo",
        de: "Sun and sky",
      },
      {
        pl: "Wiatr i deszcz",
        de: "Wind and rain",
      },
      {
        pl: "Bryza",
        de: "Breeze",
      },
      {
        pl: "Krople deszczu i tęcza",
        de: "Raindrops and rainbow",
      },
      {
        pl: "Czasem są burze z piorunami",
        de: "Sometimes there are thunderstorms",
      },
      {
        pl: "Mgła jest rano",
        de: "Fog is in the morning",
      },
      {
        pl: "Duza wilgotność",
        de: "High humidity",
      },
      {
        pl: "Powrót",
        de: "Return",
      },
      {
        pl: "Rozpływać się",
        de: "Melt",
      },
      {
        pl: "Pojawiają się zielone liście",
        de: "Green leaves appear",
      },
      {
        pl: "Rozkwitać",
        de: "Blossom",
      },
      {
        pl: "Zwierzęta wychodzią na zewnątrz",
        de: "Animals come out",
      },
      {
        pl: "Cieszyć się",
        de: "Enjoy",
      },
      {
        pl: "Obserwowac ptaki",
        de: "Watch birds",
      },
      {
        pl: "Rośliny",
        de: "Plants",
      },
      {
        pl: "Grabić i podlewać ogód",
        de: "Rake and water the garden",
      },
      {
        pl: "Oczyszczać ogrod",
        de: "Clean the garden",
      },
      {
        pl: "Kopać w ziemi",
        de: "Dig in the ground",
      },
      {
        pl: "Ciąć",
        de: "Cut",
      },
      {
        pl: "Sadzić kwiaty",
        de: "Plant flowers",
      },
      {
        pl: "Obserwować liście kwitnące",
        de: "Watch blossoming leaves",
      },
      {
        pl: "Sadzić nasiona",
        de: "Plant seeds",
      },
      {
        pl: "Słuchać śpiewu ptaków",
        de: "Listen to the birds singing",
      },
      {
        pl: "Ptaki robią zgniazda",
        de: "Birds make nests",
      },
    ],
  },
];

const ZDANIA26 = [
  {
    name: "[5klasa] Angielki grudzien 2022 - Summer, Autumn",
    zdania: [
      {
        pl: "Słońce świeci",
        de: "The sun is shining",
      },
      {
        pl: "Jest miły, ciepły letni dzień",
        de: "It is a nice, warm summer day",
      },
      {
        pl: "Jest słonecznie i bezwietrznie",
        de: "It is sunny and windless",
      },
      {
        pl: "Pada deszcz i spadają krople deszczu",
        de: "It is raining and raindrops are falling",
      },
      {
        pl: "Jest pochmurno i nudno",
        de: "It is cloudy and dull",
      },
      {
        pl: "Wszystko jest zielone",
        de: "Everything is green",
      },
      {
        pl: "Jest sucho i spokojnie",
        de: "It is dry and calm",
      },
      {
        pl: "Jest jasno i silny wiatr",
        de: "It is light and strong wind",
      },
      {
        pl: "Jest przyjemnie",
        de: "It is pleasant",
      },
      {
        pl: "Letnie dni stają się coraz dłuższe",
        de: "Summer days become longer",
      },
      {
        pl: "Mamy wakacje",
        de: "We have summer holidays",
      },
      {
        pl: "Podlewamy kwiaty",
        de: "We water flowers",
      },
      {
        pl: "Idziemy na plażę",
        de: "We got to the beach",
      },
      {
        pl: "Leżymy na słońcu",
        de: "We lie in the sun",
      },
      {
        pl: "Opalamy się",
        de: "We become sunburnt",
      },
      {
        pl: "Cieszymy się z wakacji",
        de: "We enjoy the holidays",
      },
      {
        pl: "Zbieramy jagody i grzyby",
        de: "We gather berries and mushrooms",
      },
      {
        pl: "Pływamy w rzece",
        de: "We swim in the river",
      },
      {
        pl: "Jemy owoce i warzywa",
        de: "We eat fruit and vegetables",
      },
      {
        pl: "Idziemy nurkować",
        de: "We go diving",
      },

      {
        pl: "Ciesz się złotym jesienią",
        de: "Enjoy the gold autumn",
      },
      {
        pl: "Dni stają się krótsze",
        de: "Days become shorter",
      },
      {
        pl: "Oglądac liście różnych kolorów",
        de: "Watch the leaves of different colours",
      },
      {
        pl: "Liście spadają",
        de: "Leaves are falling down",
      },
      {
        pl: "Grabic liście",
        de: "Rake the leaves",
      },
      {
        pl: "Odcinac suche gałęzie",
        de: "Chop dry branches",
      },
      {
        pl: "Zbieraj nasiona",
        de: "Gather seeds",
      },
      {
        pl: "Kopac ziemię",
        de: "Dig the land",
      },
      {
        pl: "Ptaki odlatują",
        de: "The birds fly away",
      },
      {
        pl: "Rozpocznac szkołę",
        de: "Start school",
      },
      {
        pl: "Przygotowac się na Halloween",
        de: "Prepare for Halloween",
      },
      {
        pl: "Ubierz się ciepło",
        de: "Put on warm clothes",
      },
      {
        pl: "Ciesz się piękną jesienią",
        de: "Enjoy the beautiful autumn",
      },
      {
        pl: "Ciesz się uroczą jesienią",
        de: "Enjoy the lovely autumn",
      },
      {
        pl: "Uważaj na deszcz",
        de: "Watch out for rain",
      },
      {
        pl: "Uważaj na opady deszczu",
        de: "Watch out for rainfall",
      },
      {
        pl: "Uważaj na wilgotność",
        de: "Watch out for humidity",
      },
      {
        pl: "Uważaj na wiatr",
        de: "Watch out for wind",
      },
      {
        pl: "Uważaj na wichurę",
        de: "Watch out for windstorm",
      },

      {
        pl: "Deszcz pada",
        de: "It is raining",
      },
      {
        pl: "Temperatura spada",
        de: "The temperature is dropping",
      },
      {
        pl: "Chmury są pochmurne",
        de: "The clouds are cloudy",
      },
      {
        pl: "Nastała nudna jesień",
        de: "It is a dull autumn",
      },
      {
        pl: "Ciesz się złotą jesienią",
        de: "Enjoy the gold autumn",
      },
      {
        pl: "Dni stają się coraz krótsze",
        de: "Days become shorter",
      },
      {
        pl: "Patrz na liście o różnych kolorach",
        de: "Watch the leaves of different colors",
      },
      {
        pl: "Liście spadają",
        de: "Leaves are falling down",
      },
      {
        pl: "Grab liście",
        de: "Rake the leaves",
      },
    ],
  },
];

const ZDANIA27 = [
  {
    name: "[5klasa] Niemiecki - Święta",
    lang: 'de',
    zdania: [
      {
        pl: "Święta Bożego Narodzenia są w grudniu",
        de: "Weihnachten ist im Dezember",
      },
      {
        pl: "Jest zimno i dzieci mają ferie",
        de: "Es ist kalt und die Kinder haben Ferien",
      },
      {
        pl: "Tata i dzieci dekorują choinkę",
        de: "Der Vater und die Kinder schmücken den Weihnachtsbaum",
      },
      {
        pl: "Mama gotuje jedzenie",
        de: "Die Mutter kocht das Essen",
      },
      {
        pl: "Cała rodzina sprząta",
        de: "Die ganze Familie putzt",
      },
      {
        pl: "24 grudnia jest Wigilia",
        de: "Am 24. Dezember ist Heiligabend",
      },
      {
        pl: "Stół jest juz nakryty",
        de: "Der Tisch ist schon gedeckt",
      },
      {
        pl: "Choinka stoi w salonie",
        de: "Der Weihnachtsbaum steht im Wohnzimmer",
      },
      {
        pl: "Rodzina śpiewa kolędy",
        de: "Die Familie singt Weihnachtslieder",
      },
      {
        pl: "Niemcy jedzą sałatkę ziemiaczaną, kiełbaski i kiszoną kapustę",
        de: "Die Deutschen essen Kartoffelsalat, Würstchen und Sauerkraut",
      },
      {
        pl: "Kto gotuje jedzenie?",
        de: "Wer kocht das Essen?",
      },
      {
        pl: "Od kogo są prezenty?",
        de: "Von wem sind die Geschenke?",
      },
      {
        pl: "Kto przystraja choinkę?",
        de: "Wer schmückt den Weihnachtsbaum?",
      },
      {
        pl: "Nie jedza ryb",
        de: "Sie essen keine Fisch",
      },
      {
        pl: "Dzieci czekają na prezenty od Świętego Mikołaja",
        de: "Die Kinder warten auf Geschenke vom Weihnachtsmann",
      },
      {
        pl: "Wszyscy idą chętnie na jarmark bozonarodzeniowy",
        de: "Alle gehen gerne auf den Weihnachtsmarkt",
      },
      {
        pl: "Dziadek do orzechów (przyrząd do rozbijania orzechów)",
        de: "Der Nussknacker",
      },
      {
        pl: "Wieciec adwentowy jest na stole",
        de: "Der Adventskranz steht auf dem Tisch",
      },
      {
        pl: "Wiecic adwentowy",
        de: "Der Adventskranz",
      },
      {
        pl: "Świeczka",
        de: "Die Kerze",
      },
      {
        pl: "Mam kaledarz adwentowy z czekoladkami",
        de: "Ich habe einen Adventskalender mit Schokolade",
      },
      {
        pl: "Kalendarz adwentowy",
        de: "Der Adventskalender",
      },
      {
        pl: "Choinka pachnie w domu",
        de: "Der Weihnachtsbaum riecht im Haus",
      },
      {
        pl: "Choinka",
        de: "Der Weihnachtsbaum",
      },
      {
        pl: "Szopka bożonarodzeniowa jest w kościele",
        de: "Die Weihnachtskrippe ist in der Kirche",
      },
      {
        pl: "Prezenty bożonarodzeniowe",
        de: "Die Weihnachtsgeschenke",
      },
      {
        pl: "Prezenty bożonarodzeniowe są pod choinką",
        de: "Die Weihnachtsgeschenke sind unter dem Weihnachtsbaum",
      },
      {
        pl: "Uczta świąteczna",
        de: "Das Weihnachtsfest",
      },
      {
        pl: "Uczta jest w czasie świąt",
        de: "Das Weihnachtsfest ist in der Weihnachtszeit",
      },
      {
        pl: "Uczta / uroczystość",
        de: "Das Festessen",
      },
      {
        pl: "Anioł",
        de: "Der Engel",
      },
      {
        pl: "Renifery ciągną sanki Świętego Mikołaja",
        de: "Die Rentiere ziehen den Schlitten des Nikolaus",
      },
      {
        pl: "Prezenty są pod choinką",
        de: "Die Geschenke sind unter dem Weihnachtsbaum",
      },
      {
        pl: "Prezent",
        de: "Das Geschenk",
      },
      {
        pl: "List do Mikolaja",
        de: "Der Brief an den Nikolaus",
      },
      {
        pl: "Bałwan",
        de: "Der shneemann",
      },
      {
        pl: "Sanki jadą po śniegu",
        de: "Die Schlitten fahren über den Schnee",
      },
      {
        pl: "Sanki",
        de: "Der Schlitten",
      },
      {
        pl: "Jarmark świąteczny",
        de: "Der Weihnachtsmarkt",
      },
      {
        pl: "Jarmaek świąteczny jest w centrum miasta",
        de: "Der Weihnachtsmarkt ist im Zentrum der Stadt",
      },
      {
        pl: "Na jarmaku kupuję grzaniec",
        de: "Auf dem Weihnachtsmarkt kaufe ich Glühwein",
      },
      {
        pl: "Wesołych Świąt Bożego Narodzenia",
        de: "Frohe Weihnachten",
      },
      {
        pl: "Ludzie odwiedzają rodziny, zeby zjesc ges z ziemniakami i dobrze się bawic",
        de: "Die Leute besuchen die Familien, um zu essen und gut zu feiern",
      },
      {
        pl: "Ludzie chętnie jeżdżą w góry i za granicę",
        de: "Die Leute fahren gerne ins Gebirge und ins Ausland",
      },
    ],
  },
];

const ZDANIA28 = [
  {
    name: "Modul 5 Kapitel 1",
    lang: 'de',
    zdania: [
      {
        pl: "Stefan, jak się masz?",
        de: "Stefan, wie geht's dir?",
      },
      {
        pl: "Źle, bardzo źle",
        de: "Schlecht, sehr schlecht",
      },
      {
        pl: "Dlaczego?",
        de: "Warum?",
      },
      {
        pl: "Mam ból głowy",
        de: "Mir tut der Kopf weh",
      },
      {
        pl: "Mam ból brzucha",
        de: "Mir tut der Bauch weh",
      },
      {
        pl: "Oh, Przykro mi",
        de: "Oh, tut mir Leid",
      },
      {
        pl: "Co cię boli?",
        de: "Was tut dir weh?",
      },
      {
        pl: "Bolą mnie uszy",
        de: "Mir tun die Ohren weh",
      },
      {
        pl: "Co masz raz (nie jest w parze)?",
        de: "Was hast du einmal?",
      },
      {
        pl: "Mam gorączkę",
        de: "Ich habe Fieber",
      },
      {
        pl: "Mam kaszel",
        de: "Ich habe Husten",
      },
      {
        pl: "Mam katar",
        de: "Ich habe Schnupfen",
      },
      {
        pl: "Mam ból gardła",
        de: "Mir tut der Hals weh",
      },
      {
        pl: "Mam ból pleców",
        de: "Mir tut der Rücken weh",
      },
      {
        pl: "Mam ból brzucha",
        de: "Mir tut der Bauch weh",
      },
      {
        pl: "Mam ból głowy",
        de: "Mir tut der Kopf weh",
      },
      {
        pl: "Mam ból nóg",
        de: "Mir tun die Beine weh",
      },
      {
        pl: "Mam ból stóp",
        de: "Mir tun die Füße weh",
      },
      {
        pl: "Mam ból rąk",
        de: "Mir tun die Hände weh",
      },
      {
        pl: "Mam ból ramion",
        de: "Mir tun die Arme weh",
      },
      {
        pl: "Mam ból kolana",
        de: "Mir tut das Knie weh",
      },
      {
        pl: "Mam ból łokcia",
        de: "Mir tut der Ellenbogen weh",
      },
      {
        pl: "Mam ból zęba",
        de: "Mir tut der Zahn weh",
      },
      {
        pl: "Mam ból oka",
        de: "Mir tut das Auge weh",
      },
      {
        pl: "Mam ból szyi",
        de: "Mir tut der Hals weh",
      },
      {
        pl: "Jakie masz rzeczy podwójne",
        de: "Was hast du zweimal?",
      },
      {
        pl: "Usta",
        de: "Die Lippen",
      },
      {
        pl: "Ból głowy",
        de: "Der Kopfschmerz",
      },
      {
        pl: "Ból gardła",
        de: "Der Halsschmerz",
      },
      {
        pl: "Ból pleców",
        de: "Der Rückenschmerz",
      },
      {
        pl: "Ból brzucha",
        de: "Der Bauchschmerz",
      },
      {
        pl: "Ból nóg",
        de: "Der Beinschmerz",
      },
      {
        pl: "Grypa",
        de: "Die Grippe",
      },
      {
        pl: "Katar",
        de: "Die Schnupfen",
      },
      {
        pl: "Masz ból głowy?",
        de: "Hast du Kopfschmerzen?",
      },
      {
        pl: "Masz ból gardła?",
        de: "Hast du Halsschmerzen?",
      },
      {
        pl: "Masz katar?",
        de: "Hast du Schnupfen?",
      },
      {
        pl: "Co jego boli? [w celowniku]",
        de: "Was tut ihm weh?",
      },
      {
        pl: "Co ją boli? [w celowniku]",
        de: "Was tut ihr weh?",
      },
      {
        pl: "Co cię boli? [w celowniku]",
        de: "Was tut dir weh?",
      },
      {
        pl: "Co ich boli? [w celowniku]",
        de: "Was tut ihnen weh?",
      },
      {
        pl: "Co boli dzieci? [w celowniku]",
        de: "Was tut den Kindern weh?",
      },
      {
        pl: "Co boli tą Panią? [w celowniku]",
        de: "Was tut der Frau weh?",
      },
      {
        pl: "Co boli tego Pana? [w celowniku]",
        de: "Was tut dem Mann weh?",
      },
      {
        pl: "Co boli tą dziewczynkę? [w celowniku]",
        de: "Was tut dem Mädchen weh?",
      },
      {
        pl: "Tabletki na gordło",
        de: "Die Halspastillen",
      },
      {
        pl: "Syrop na kaszel",
        de: "Der Hustensaft",
      },
      {
        pl: "Ból dupy",
        de: "Der Arschschmerz",
      },
      {
        pl: "Herbata rumiankowa",
        de: "Der Kamillentee",
      },
      {
        pl: "Krope do nosa",
        de: "Die Nasentropfen",
      },
      {
        pl: "Tabletki przeciwbólowe",
        de: "Die Schmerztabletten",
      },
      {
        pl: "Tabletki na gorączkę",
        de: "Die Fiebertabletten",
      },
      {
        pl: "Mamusiu, mam katar",
        de: "Mutti, ich habe Schnupfen",
      },
      {
        pl: "Weź krople do nosa",
        de: "Nimm Nasentropfen",
      },
      {
        pl: "Weź tableki na ból",
        de: "Nimm Schmerztabletten",
      },
      {
        pl: "Panie doktorze, mam kaszel",
        de: "Herr Doktor, ich habe Husten",
      },
      {
        pl: "Mój syn ma ból brzucha",
        de: "Mein Sohn hat Bauchschmerzen",
      },
      {
        pl: "Jest źle rano jak idzie do szłoły",
        de: "Es ist morgens schlecht, wenn er zur Schule geht",
      },
      {
        pl: "Czy to mozliwe?",
        de: "Ist das möglich?",
      },
      {
        pl: "Jaki masz problem?",
        de: "Welches Problem hast du?",
      },
      {
        pl: "Masz ładną twarz",
        de: "Du hast ein schönes Gesicht",
      },
      {
        pl: "Ona ma niebieskie oczy",
        de: "Sie hat blaue Augen",
      },
      {
        pl: "Mam małe stopy",
        de: "Ich habe kleine Füße",
      },
      {
        pl: "Życzę ci zdrowia",
        de: "Ich wünsche dir gute Besserung",
      },
      {
        pl: "Kogo boli głowa?",
        de: "Wem tut der Kopf weh?",
      },
      {
        pl: "Czy tę Panią boli brzuch?",
        de: "Hat der Frau der Bauch weh?",
      },
      {
        pl: "W poniedziałek nie mogę iśc do kina, poniewaz muszie isc do dentysty",
        de: "Am Montag kann ich nicht ins Kino gehen, dann ich gehe zum Zehnartz",
      },
      {
        pl: "Oni nie chcą iśc na basen poniewaz musza isc do Kuchni",
        de: "Sie wollen nicht ins Schwimmbad gehen, denn sie müssen in die Küche gehen",
      },
      {
        pl: "Czy masz czas w środę o 15:00?",
        de: "Hast du am Mittwoch um 15 Uhr Zeit?",
      },
      {
        pl: "Co powinienem zrobic?",
        de: "Was soll ich tun?",
      },
      {
        pl: "Wypij herbatę rumiankową!",
        de: "Trinken Kamillentee!",
      },
      {
        pl: "Dziękuję i do widzenia!",
        de: "Vielen Dank und auf Wiedersehen!",
      },
      {
        pl: "Ona ma krótką szyję",
        de: "Sie hat einen kurzen Hals",
      },
    ],
  },
];

const ZDANIA29 = [
  {
    name: "Modul 5 Kapitel 2",
    lang: 'de',
    zdania: [
      {
        pl: "Mój syn jest chory i leży w szpitalu",
        de: "Mein Sohn ist krank und liegt im Krankenhaus",
      },
      {
        pl: "Życzę Ci dużo zdrowia",
        de: "Ich wünsche dir viel Gesundheit",
      },
      {
        pl: "Co robisz dla swojego zdrowia?",
        de: "Was tust du für deine Gesundheit?",
      },
      {
        pl: "Co to jest zdrowe?",
        de: "Was ist gesund?",
      },
      {
        pl: "Co to jest niezdrowe",
        de: "Was ist ungesund?",
      },
      {
        pl: "Frytki i chipsy są niezdrowe",
        de: "Pommfrittes und Chips sind ungesund",
      },
      {
        pl: "Napoje gazowane są niezdrowe",
        de: "Softgetränke sind ungesund",
      },
      {
        pl: "Cukier jest niezdrowy",
        de: "Zucker ist ungesund",
      },
      {
        pl: "Jezdzenie autem jest niezdrowe",
        de: "Auto fahren ist ungesund",
      },
      {
        pl: "Chodzenie na nogach jest zdrowe",
        de: "Zu Fuß gehen ist gesund",
      },
      {
        pl: "Jedzenie owoców jest zdrowe",
        de: "Obst essen ist gesund",
      },
      {
        pl: "Jedzenie 5 razy dziennie jest zdrowe",
        de: "Fünfmal am Tag essen ist gesund",
      },
      {
        pl: "Jedzenie słodyczy jest niezdrowe",
        de: "Süßigkeiten essen ist ungesund",
      },
      {
        pl: "Uprawianie sportu jest zdrowe",
        de: "Sport treiben ist gesund",
      },
      {
        pl: "Jedzenie kiełbasy jest niezdrowe, lepsze są marchewki",
        de: "Wurst essen ist ungesund, besser sind Karotten",
      },
      {
        pl: "Uwaga, nie pij duzo kawy",
        de: "Achtung, trink nicht viel Kaffee",
      },
      {
        pl: "Nigdy nie pij alkoholu",
        de: "Trinke nie Alkohol",
      },
      {
        pl: "Niegdy nie jedz słodyczy",
        de: "Iss nie Süßigkeiten",
      },
      {
        pl: "Nigdy nie jedz chipsów",
        de: "Iss nie Chips",
      },
      {
        pl: "Peter Malin zyje ryzykownie (niebezpiecznie)",
        de: "Peter Malin lebt gefährlich",
      },
      {
        pl: "On pali duzo papierosów",
        de: "Er raucht viel Zigaretten",
      },
      {
        pl: "On wie, ze palenie szkodzi zdrowiu",
        de: "Er weiß, Rauchen schadet der Gesundheit",
      },
      {
        pl: "On takze pije za duzo kawy",
        de: "Er trinkt auch zu viel Kaffee",
      },
      {
        pl: "Kazdego dnia od osmiu do 10 filizanej kawy",
        de: "Jeden Tag von acht bis zehn Tassen Kaffee",
      },
      {
        pl: "On mowi, ze kawa utrzymuej go w formie",
        de: "Er meint, Kaffee hält ihn fit",
      },
      {
        pl: "Kawa szkodzi zoladkowi",
        de: "Kaffee schadet dem Magen",
      },
      {
        pl: "Pan Malin jest smakoszem",
        de: "Herr Malin ist ein Feinschmecker",
      },
      {
        pl: "Jego ulubione jedzenie to pieczen wieprzowa z kapustą kiszoną",
        de: "Sein Lieblingsessen ist Schweinebraten mit Sauerkraut",
      },
      {
        pl: "Daltego ma 15 kilogramów nadwagi",
        de: "Deshalb hat er 15 Kilo Übergewicht",
      },
      {
        pl: "On ma zawsze duzo do zrobienia w pracy",
        de: "Er hat immer viel zu tun auf der Arbeit",
      },
      {
        pl: "On pracuje wiecej niz jego koledzy i kazdego dnia ma nadgodziny",
        de: "Er arbeitet mehr als seine Kollegen und hat jeden Tag Überstunden",
      },
      {
        pl: "On chcialby uprawiac sport, ale nie ma czasu",
        de: "Er möchte Sport treiben, aber er hat keine Zeit",
      },
      {
        pl: "Pan Malin nie ma wolnego czasu",
        de: "Herr Malin hat keine Freizeit",
      },
      {
        pl: "Pan Malin ma nadwage",
        de: "Herr Malin hat Übergewicht",
      },
      {
        pl: "Pan Main pije za duzo kawy",
        de: "Herr Malin trinkt zu viel Kaffee",
      },
      {
        pl: "Pan Malin nie uprawia sportu",
        de: "Herr Malin treibt keinen Sport",
      },
      {
        pl: "Pan Malin je duzo i chetnie",
        de: "Herr Malin isst viel und gern",
      },
      {
        pl: "Pan Malin pacuje w nadgodzinach",
        de: "Herr Malin macht Überstunden",
      },
      {
        pl: "Dziś nie wolno ci więcej palic",
        de: "Heute darfst du nicht mehr rauchen",
      },
      {
        pl: "Nie wolno ci więcej pic kawy",
        de: "Du darfst nicht mehr Kaffee trinken",
      },
      {
        pl: "Nie wolno ci jesc tlustych potraw",
        de: "Du darfst keine fettigen Speisen essen",
      },
      {
        pl: "Muisz uprawic sport",
        de: "Du musst Sport treiben",
      },
      {
        pl: "Musisz jezdzic rowerem",
        de: "Du musst Fahrrad fahren",
      },
      {
        pl: "Musisz chodzic na nogach",
        de: "Du musst zu Fuß gehen",
      },
      {
        pl: "Musisz jesc zdrowe jedzenie",
        de: "Du musst gesund essen",
      },
      {
        pl: "Musisz jesc 5 razy dziennie",
        de: "Du musst fünfmal am Tag essen",
      },
      {
        pl: "To pomaga twoim mięśniom",
        de: "Das hilft deinen Muskeln",
      },
      {
        pl: "Zależy mi na wysportowanym i zdrowym mężczyźnie",
        de: "Ich will einen sportlichen und gesunden Mann",
      },
      {
        pl: "Czy wolno ci jesc słodycze?",
        de: "Darfst du Süßigkeiten essen?",
      },
      {
        pl: "Nie wolno ci jeśc chipsów",
        de: "Du darfst keine Chips essen",
      },
      {
        pl: "Nie wolno ci isc do kina",
        de: "Du darfst nicht ins Kino gehen",
      },
      {
        pl: "Nie wolno ci jest frytki",
        de: "Du darfst keine Pommes essen",
      },
      {
        pl: "Wolno ci pic duzo wody",
        de: "Du darfst viel Wasser trinken",
      },
      {
        pl: "Musisz pic duzo wody",
        de: "Du musst viel Wasser trinken",
      },
      {
        pl: "Musisz isc do kina",
        de: "Du musst ins Kino gehen",
      },
      {
        pl: "Nie wolno ci palic",
        de: "Du darfst keine Zigaretten rauchen",
      },
      {
        pl: "Nie wolno ogladac telewizji",
        de: "Du darfst kein Fernsehen schauen",
      },
      {
        pl: "pozwalac",
        de: "dürfen",
      },
      {
        pl: "Kto moze isc do kina?",
        de: "Wer darf ins Kino gehen?",
      },
      {
        pl: "Czy im wolno palic?",
        de: "Dürfen sie rauchen?",
      },
      {
        pl: "Jemu nie wolno samemu jechac samochodem",
        de: "Er darf nicht alleine Auto fahren",
      },
      {
        pl: "Jej nie wolno samej wychodzic z domu wieczorem",
        de: "Sie darf nicht alleine nach Hause gehen",
      },
      {
        pl: "Im Nie wolno jesc tych kiełbas",
        de: "Sie dürfen diese Würste nicht essen",
      },
      {
        pl: "Kochanie czy moge pic kawe?",
        de: "Liebling, darf ich Kaffee trinken?",
      },
      {
        pl: "Skarbie czy mogo isc do kina?",
        de: "Liebling, darf ich ins Kino gehen?",
      },
      {
        pl: "Wy nie mozecie jest czekolady",
        de: "Ihr dürft keine Schokolade essen",
      },
      {
        pl: "Tłuse jedzenie na prawde jest niezdrowe",
        de: "Fette Speisen sind wirklich ungesund",
      },
      {
        pl: "Woda na prawde jest zdrowa",
        de: "Wasser ist wirklich gesund",
      },
    ],
  },
];

export {
  ZDANIA21,
  ZDANIA22,
  ZDANIA23,
  ZDANIA24,
  ZDANIA25,
  ZDANIA26,
  ZDANIA27,
  ZDANIA28,
  ZDANIA29,
};
